var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _path3, _rect9, _rect10, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect11, _path11, _rect12, _rect13, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path25, _rect21, _rect22, _rect23, _path26, _path27, _rect24, _rect25, _path28, _g, _g2, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g3, _g4, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g5, _path59, _path60, _path61, _path62, _path63, _g6, _g7, _path64, _g8, _path65, _g9, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g10, _path80, _path81, _g11, _path82, _path83, _path84, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 684.363,
    height: 510,
    viewBox: "0 0 684.363 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_187",
    "data-name": "Ret\\xE2ngulo 187",
    width: 684.363,
    height: 510,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_174",
    "data-name": "Ret\\xE2ngulo 174",
    width: 176.543,
    height: 336.322,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_175",
    "data-name": "Ret\\xE2ngulo 175",
    width: 176.542,
    height: 336.322,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_176",
    "data-name": "Ret\\xE2ngulo 176",
    width: 28.393,
    height: 28.364,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_177",
    "data-name": "Ret\\xE2ngulo 177",
    width: 56.725,
    height: 25.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_178",
    "data-name": "Ret\\xE2ngulo 178",
    width: 28.643,
    height: 7.72,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_179",
    "data-name": "Ret\\xE2ngulo 179",
    width: 63.283,
    height: 163.953,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 16.912,
    height: 77.133,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_181",
    "data-name": "Ret\\xE2ngulo 181",
    width: 83.052,
    height: 167.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_182",
    "data-name": "Ret\\xE2ngulo 182",
    width: 10.376,
    height: 18.374,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_183",
    "data-name": "Ret\\xE2ngulo 183",
    width: 47.168,
    height: 4.843,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_184",
    "data-name": "Ret\\xE2ngulo 184",
    width: 73.34,
    height: 5.323,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_185",
    "data-name": "Ret\\xE2ngulo 185",
    width: 49.574,
    height: 6.224,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_149",
    "data-name": "Ret\\xE2ngulo 149",
    width: 684.363,
    height: 0.342,
    transform: "translate(0 448.184)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_150",
    "data-name": "Ret\\xE2ngulo 150",
    width: 45.335,
    height: 0.342,
    transform: "translate(125.519 468.892)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_151",
    "data-name": "Ret\\xE2ngulo 151",
    width: 26.27,
    height: 0.342,
    transform: "translate(84.902 468.892)",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_152",
    "data-name": "Ret\\xE2ngulo 152",
    width: 26.269,
    height: 0.342,
    transform: "translate(261.924 473.929)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_153",
    "data-name": "Ret\\xE2ngulo 153",
    width: 59.121,
    height: 0.341,
    transform: "translate(366.029 481.572)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_154",
    "data-name": "Ret\\xE2ngulo 154",
    width: 8.668,
    height: 0.341,
    transform: "translate(345.175 481.572)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_155",
    "data-name": "Ret\\xE2ngulo 155",
    width: 128.217,
    height: 0.342,
    transform: "translate(492.286 473.929)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M310.32,387.14H46.02a7.821,7.821,0,0,1-7.813-7.813V7.813A7.822,7.822,0,0,1,46.02,0h264.3a7.822,7.822,0,0,1,7.811,7.813V379.328a7.821,7.821,0,0,1-7.811,7.813M46.02.342a7.478,7.478,0,0,0-7.471,7.471V379.328a7.478,7.478,0,0,0,7.471,7.47h264.3a7.479,7.479,0,0,0,7.469-7.47V7.813A7.479,7.479,0,0,0,310.32.342Z",
    transform: "translate(14.088)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M526.616,387.14h-264.3a7.821,7.821,0,0,1-7.811-7.813V7.813A7.822,7.822,0,0,1,262.316,0h264.3a7.822,7.822,0,0,1,7.813,7.813V379.328a7.821,7.821,0,0,1-7.813,7.813M262.316.342a7.478,7.478,0,0,0-7.469,7.471V379.328a7.478,7.478,0,0,0,7.469,7.47h264.3a7.479,7.479,0,0,0,7.471-7.47V7.813A7.479,7.479,0,0,0,526.616.342Z",
    transform: "translate(93.843)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_156",
    "data-name": "Ret\\xE2ngulo 156",
    width: 30.097,
    height: 119.4,
    transform: "translate(335.899 331.266)",
    fill: "#e0e0e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M264.838,333.64h5.716v-16.26h-11.71Z",
    transform: "translate(95.443 117.026)",
    fill: "#fafafa"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_157",
    "data-name": "Ret\\xE2ngulo 157",
    width: 30.097,
    height: 119.4,
    transform: "translate(204.016 331.266)",
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_158",
    "data-name": "Ret\\xE2ngulo 158",
    width: 136.874,
    height: 109.423,
    transform: "translate(229.122 331.265)",
    fill: "#fafafa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M298.114,275.046H171.168V246.1H298.114Zm.528-29.478h-128v30.008h128Z",
    transform: "translate(62.919 90.548)",
    fill: "#e0e0e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M173.115,333.64H167.4v-16.26h11.709Z",
    transform: "translate(61.725 117.026)",
    fill: "#fafafa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M215.188,257.346a3.026,3.026,0,1,0,3.026-3.028,3.027,3.027,0,0,0-3.026,3.028",
    transform: "translate(79.346 93.774)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M298.114,300.515H171.168v-28.95H298.114Zm.528-29.48h-128v30.008h128Z",
    transform: "translate(62.919 99.938)",
    fill: "#e0e0e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M215.188,282.813a3.026,3.026,0,1,0,3.026-3.028,3.027,3.027,0,0,0-3.026,3.028",
    transform: "translate(79.346 103.164)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M298.114,325.982H171.168v-28.95H298.114Zm.528-29.48h-128V326.51h128Z",
    transform: "translate(62.919 109.328)",
    fill: "#e0e0e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M215.188,308.28a3.026,3.026,0,1,0,3.026-3.028,3.027,3.027,0,0,0-3.026,3.028",
    transform: "translate(79.346 112.555)",
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_159",
    "data-name": "Ret\\xE2ngulo 159",
    width: 30.097,
    height: 188.742,
    transform: "translate(185.628 261.924)",
    fill: "#e0e0e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M155.048,333.64h5.717v-16.26H149.055Z",
    transform: "translate(54.96 117.026)",
    fill: "#fafafa"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_160",
    "data-name": "Ret\\xE2ngulo 160",
    width: 30.097,
    height: 188.742,
    transform: "translate(73.143 261.924)",
    fill: "#e0e0e0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_161",
    "data-name": "Ret\\xE2ngulo 161",
    width: 117.474,
    height: 178.764,
    transform: "translate(98.251 261.924)",
    fill: "#fafafa"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M183,235.7H75.647V195.23H183Zm.623-41.1H75.023v41.72h108.6Z",
    transform: "translate(27.663 71.756)",
    fill: "#e0e0e0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M167.859,335.752H116.722V228.394h51.137Zm.623-107.982H116.1v108.6h52.384Z",
    transform: "translate(42.808 83.985)",
    fill: "#e0e0e0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M126.783,335.752H75.646V228.394h51.137Zm.624-107.982H75.023v108.6h52.384Z",
    transform: "translate(27.663 83.985)",
    fill: "#e0e0e0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M77.5,333.64H71.783v-16.26H83.493Z",
    transform: "translate(26.468 117.026)",
    fill: "#fafafa"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_222",
    "data-name": "Caminho 222",
    d: "M112.485,210.663a3.027,3.027,0,1,0,3.028-3.028,3.028,3.028,0,0,0-3.028,3.028",
    transform: "translate(41.476 76.561)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_223",
    "data-name": "Caminho 223",
    d: "M120.4,266.389a3.027,3.027,0,1,0,3.028-3.028,3.028,3.028,0,0,0-3.028,3.028",
    transform: "translate(44.396 97.108)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_224",
    "data-name": "Caminho 224",
    d: "M104.566,266.389a3.027,3.027,0,1,0,3.028-3.028,3.028,3.028,0,0,0-3.028,3.028",
    transform: "translate(38.556 97.108)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    "data-name": "Caminho 225",
    d: "M105.787,152.916H93.09s2.2,11.737,2.2,18.643-9.658,33.98,4.145,33.98,4.145-27.073,4.145-33.98,2.2-18.643,2.2-18.643",
    transform: "translate(33.926 56.384)",
    fill: "#e0e0e0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    "data-name": "Caminho 226",
    d: "M66.8,173.2v8.249a16.666,16.666,0,0,0,16.618,16.616H91.67a16.665,16.665,0,0,0,16.616-16.616V173.2Z",
    transform: "translate(24.632 63.862)",
    fill: "#f5f5f5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_227",
    "data-name": "Caminho 227",
    d: "M195.667,229.312c0,9.57,10.719,17.4,23.819,17.4h11.826c13.1,0,23.819-7.83,23.819-17.4Z",
    transform: "translate(72.148 84.554)",
    fill: "#e0e0e0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_228",
    "data-name": "Caminho 228",
    d: "M413.374,263.677c-7.172,5.854-17.071,16.574-26.141,31.656-6.042,10.042-9.682,20.566-11.282,34.471.036-15.739.083-32.65.14-48.61,1.822-4.106,5.983-13.572,8.968-21.051,9.959-24.953,13.669-31.089,22.628-52.612,11.946-28.708,24.191-62.771,20.686-60.049-7.143,5.546-34.519,56.808-37.479,64.145-10.178,25.238-13.013,43.635-14.774,61.39.055-14.99.114-28.754.17-39.374.183-34.641.773-45.821,1.061-49.267,1.109-1.752,2.416-3.794,3.177-4.895,6.43-9.3,8.91-17.219,14.97-31.087,8.586-19.651,15.98-54.54,13.819-52.779-9,7.325-16.1,23.078-25.43,43.15s-6.662,31.615-8.512,48.758c-.389,3.364-.686,16.059-.9,33.654-2.419-18.745-6.959-31.1-15.239-42.322-10.185-13.806-20.039-23.133-27.269-28S344.448,179.9,353.875,194.7c8.4,13.182,16.13,24.815,20.49,36.271-.23,23.846-.337,54.043-.338,82.151-2.163-12.792-5.694-26.566-10.405-37.232-5.661-12.817-14.372-32.472-21.3-39.14-1.666-1.6,7.249,36.628,12.969,46.794s9.922,19.745,13.522,25.508c.84,1.344,3.627,6.529,5.219,9.51.015,34.314.19,64.593.489,74.9H376c-.1-2.659-.118-20.115-.086-43.218,3.571-12.543,11.734-26.859,18.472-39.918,7.354-14.254,26.16-52.5,18.988-46.648",
    transform: "translate(121.829 35.232)",
    fill: "#e0e0e0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_229",
    "data-name": "Caminho 229",
    d: "M391.286,339.9h-42.9l-3.237-42.051h49.377Z",
    transform: "translate(127.265 109.823)",
    fill: "#f0f0f0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_230",
    "data-name": "Caminho 230",
    d: "M399.013,305.246H343.241l-1.6-14.188H400.61Z",
    transform: "translate(125.973 107.321)",
    fill: "#f5f5f5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_162",
    "data-name": "Ret\\xE2ngulo 162",
    width: 76.72,
    height: 84.244,
    transform: "translate(93.357 28.12)",
    fill: "#e0e0e0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_163",
    "data-name": "Ret\\xE2ngulo 163",
    width: 79.247,
    height: 84.244,
    transform: "translate(99.141 28.12)",
    fill: "#f5f5f5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_164",
    "data-name": "Ret\\xE2ngulo 164",
    width: 65.969,
    height: 70.966,
    transform: "translate(105.779 34.759)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_165",
    "data-name": "Ret\\xE2ngulo 165",
    width: 33.988,
    height: 36.564,
    transform: "translate(121.769 51.961)",
    fill: "#f5f5f5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_166",
    "data-name": "Ret\\xE2ngulo 166",
    width: 71.27,
    height: 78.26,
    transform: "translate(489.978 37.941)",
    fill: "#e0e0e0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_167",
    "data-name": "Ret\\xE2ngulo 167",
    width: 73.617,
    height: 78.26,
    transform: "translate(495.349 37.941)",
    fill: "#f5f5f5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_168",
    "data-name": "Ret\\xE2ngulo 168",
    width: 61.282,
    height: 65.925,
    transform: "translate(501.518 44.109)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_231",
    "data-name": "Caminho 231",
    d: "M413.068,61.458A19.119,19.119,0,1,1,393.95,42.34a19.119,19.119,0,0,1,19.118,19.118",
    transform: "translate(138.21 15.612)",
    fill: "#f5f5f5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_169",
    "data-name": "Ret\\xE2ngulo 169",
    width: 56.913,
    height: 62.493,
    transform: "translate(192.866 78.353)",
    fill: "#e0e0e0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_170",
    "data-name": "Ret\\xE2ngulo 170",
    width: 58.787,
    height: 62.493,
    transform: "translate(197.156 78.353)",
    fill: "#f5f5f5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_171",
    "data-name": "Ret\\xE2ngulo 171",
    width: 48.936,
    height: 52.644,
    transform: "translate(202.082 83.277)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_232",
    "data-name": "Caminho 232",
    d: "M169.124,70.351,155.741,93.532h26.767Z",
    transform: "translate(57.426 25.94)",
    fill: "#f5f5f5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_233",
    "data-name": "Caminho 233",
    d: "M586.873,365.461c0,8.56-118.815,15.5-265.381,15.5s-265.381-6.938-265.381-15.5,118.815-15.5,265.381-15.5,265.381,6.939,265.381,15.5",
    transform: "translate(20.69 129.041)",
    fill: "#f5f5f5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_172",
    "data-name": "Ret\\xE2ngulo 172",
    width: 8.742,
    height: 1.407,
    transform: "translate(326.425 21.375)",
    fill: "#4d4c92"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_173",
    "data-name": "Ret\\xE2ngulo 173",
    width: 23.51,
    height: 1.406,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 447.34, 100.658)",
    fill: "#4d4c92"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_234",
    "data-name": "Caminho 234",
    d: "M373.172,20.242H211.664L196.63,356.564H358.138Z",
    transform: "translate(72.503 7.464)",
    fill: "#4d4c92"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    transform: "translate(264.311 32.32)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_235",
    "data-name": "Caminho 235",
    d: "M369.65,23.613H208.141L193.107,359.936H354.615Z",
    transform: "translate(-193.107 -23.613)",
    fill: "#fafafa"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    transform: "translate(259.489 36.935)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    "data-name": "Caminho 236",
    d: "M366.127,26.985H204.619L189.584,363.307H351.093Z",
    transform: "translate(-189.584 -26.985)",
    fill: "#407bff"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    "data-name": "Caminho 237",
    d: "M342.583,134.153H204.728l-1.15,25.74H341.432Z",
    transform: "translate(75.065 49.466)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    "data-name": "Caminho 238",
    d: "M280.153,120.438H205.17l-.515,11.516h74.983Z",
    transform: "translate(75.462 44.409)",
    fill: "#4d4c92"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_239",
    "data-name": "Caminho 239",
    d: "M340.315,184.9H202.461l-1.151,25.74H339.164Z",
    transform: "translate(74.228 68.176)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_240",
    "data-name": "Caminho 240",
    d: "M309.743,229.084h-92.7l-1.378,30.85h92.7Z",
    transform: "translate(79.52 84.469)",
    fill: "#4d4c92"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_241",
    "data-name": "Caminho 241",
    d: "M304.885,263.513h-92.7a.171.171,0,0,1-.119-.051.163.163,0,0,1-.044-.12l1.38-30.85a.162.162,0,0,1,.161-.156h92.7a.174.174,0,0,1,.119.051.159.159,0,0,1,.044.119l-1.38,30.85a.162.162,0,0,1-.161.157m-92.531-.327h92.375l1.365-30.523H213.718Z",
    transform: "translate(78.178 85.669)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_242",
    "data-name": "Caminho 242",
    d: "M264.788,171.181H202.9l-.515,11.516h61.886Z",
    transform: "translate(74.626 63.119)",
    fill: "#4d4c92"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_243",
    "data-name": "Caminho 243",
    d: "M302,82.872a36.236,36.236,0,0,1-7.617,20.6,36.81,36.81,0,0,1-29.016,14.459,33.262,33.262,0,0,1-33.483-35.064,37.021,37.021,0,0,1,36.619-35.064A33.237,33.237,0,0,1,302,82.872",
    transform: "translate(85.49 17.628)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_244",
    "data-name": "Caminho 244",
    d: "M290.537,55.681a9.624,9.624,0,0,1-2.024,5.475A9.782,9.782,0,0,1,280.8,65a8.838,8.838,0,0,1-8.9-9.317,9.837,9.837,0,0,1,9.73-9.317,8.832,8.832,0,0,1,8.9,9.317",
    transform: "translate(100.255 17.096)",
    fill: "#4d4c92"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_245",
    "data-name": "Caminho 245",
    d: "M217.488,144.667a4.356,4.356,0,0,1-4.309,4.125,3.912,3.912,0,0,1-3.941-4.125,4.356,4.356,0,0,1,4.309-4.124,3.911,3.911,0,0,1,3.941,4.124",
    transform: "translate(77.151 51.822)",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_246",
    "data-name": "Caminho 246",
    d: "M230.975,144.667a4.356,4.356,0,0,1-4.309,4.125,3.912,3.912,0,0,1-3.941-4.125,4.356,4.356,0,0,1,4.309-4.124,3.911,3.911,0,0,1,3.941,4.124",
    transform: "translate(82.124 51.822)",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_247",
    "data-name": "Caminho 247",
    d: "M244.463,144.667a4.356,4.356,0,0,1-4.309,4.125,3.912,3.912,0,0,1-3.941-4.125,4.356,4.356,0,0,1,4.309-4.124,3.91,3.91,0,0,1,3.941,4.124",
    transform: "translate(87.097 51.822)",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_248",
    "data-name": "Caminho 248",
    d: "M215.22,195.411a4.355,4.355,0,0,1-4.309,4.124,3.911,3.911,0,0,1-3.941-4.124,4.357,4.357,0,0,1,4.309-4.125,3.911,3.911,0,0,1,3.941,4.125",
    transform: "translate(76.314 70.532)",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_249",
    "data-name": "Caminho 249",
    d: "M228.707,195.411a4.355,4.355,0,0,1-4.309,4.124,3.91,3.91,0,0,1-3.941-4.124,4.357,4.357,0,0,1,4.309-4.125,3.911,3.911,0,0,1,3.941,4.125",
    transform: "translate(81.287 70.532)",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_250",
    "data-name": "Caminho 250",
    d: "M242.194,195.411a4.355,4.355,0,0,1-4.309,4.124,3.91,3.91,0,0,1-3.941-4.124,4.357,4.357,0,0,1,4.309-4.125,3.911,3.911,0,0,1,3.941,4.125",
    transform: "translate(86.26 70.532)",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_251",
    "data-name": "Caminho 251",
    d: "M255.682,195.411a4.355,4.355,0,0,1-4.309,4.124,3.911,3.911,0,0,1-3.941-4.124,4.357,4.357,0,0,1,4.309-4.125,3.911,3.911,0,0,1,3.941,4.125",
    transform: "translate(91.234 70.532)",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252",
    "data-name": "Caminho 252",
    d: "M269.169,195.411a4.355,4.355,0,0,1-4.309,4.124,3.91,3.91,0,0,1-3.941-4.124,4.357,4.357,0,0,1,4.309-4.125,3.911,3.911,0,0,1,3.941,4.125",
    transform: "translate(96.207 70.532)",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253",
    "data-name": "Caminho 253",
    d: "M275.881,68.684a14.975,14.975,0,0,1-14.816,14.181,13.444,13.444,0,0,1-13.548-14.181A14.974,14.974,0,0,1,262.333,54.5a13.443,13.443,0,0,1,13.548,14.181",
    transform: "translate(91.261 20.097)",
    fill: "#4d4c92"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254",
    "data-name": "Caminho 254",
    d: "M292.823,91.425a36.814,36.814,0,0,1-29.016,14.459A33.256,33.256,0,0,1,236.1,91.425C242.752,84.8,253.281,80.5,264.942,80.5s21.82,4.3,27.881,10.928",
    transform: "translate(87.055 29.681)",
    fill: "#4d4c92"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129",
    transform: "translate(338.764 74.598)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255",
    "data-name": "Caminho 255",
    d: "M275.881,68.684a14.975,14.975,0,0,1-14.816,14.181,13.444,13.444,0,0,1-13.548-14.181A14.974,14.974,0,0,1,262.333,54.5a13.443,13.443,0,0,1,13.548,14.181",
    transform: "translate(-247.503 -54.502)",
    fill: "#4d4c92"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_132",
    "data-name": "Grupo 132",
    transform: "translate(323.152 110.177)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_256",
    "data-name": "Caminho 256",
    d: "M292.823,91.425a36.814,36.814,0,0,1-29.016,14.459A33.256,33.256,0,0,1,236.1,91.425C242.752,84.8,253.281,80.5,264.942,80.5s21.82,4.3,27.881,10.928",
    transform: "translate(-236.097 -80.496)",
    fill: "#4d4c92"
  }))))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_257",
    "data-name": "Caminho 257",
    d: "M136.437,158.8c-1.3,2.843-2.661,5.97-3.858,9.021-1.209,3.08-2.413,6.162-3.463,9.288A117.679,117.679,0,0,0,124.223,196l-.311,2.016a3.077,3.077,0,0,0,.1,1.02,10.494,10.494,0,0,0,1.5,3.174,39.78,39.78,0,0,0,6.081,6.818,92.588,92.588,0,0,0,7.555,6.318c2.627,2.02,5.4,4,8.107,5.85l-2.551,4.8a96.964,96.964,0,0,1-18.45-10.523,44.019,44.019,0,0,1-8.267-7.773,19.41,19.41,0,0,1-3.273-5.847,13.177,13.177,0,0,1-.661-4.031c.01-.338.027-.813.051-1.04l.07-.68.136-1.359a106.515,106.515,0,0,1,4.469-20.994c1.068-3.378,2.206-6.722,3.507-10,1.328-3.3,2.638-6.473,4.3-9.8Z",
    transform: "translate(42.056 56.764)",
    fill: "#e58a7b"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_258",
    "data-name": "Caminho 258",
    d: "M137.6,203.8l9.671-4.907-2.5,10.631s-6.641,1.855-9.73-1.369Z",
    transform: "translate(49.795 73.338)",
    fill: "#e58a7b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_259",
    "data-name": "Caminho 259",
    d: "M153.511,200.64l-2.573,8.786-8.783.1,2.5-10.631Z",
    transform: "translate(52.416 73.338)",
    fill: "#e58a7b"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_260",
    "data-name": "Caminho 260",
    d: "M160.432,120.049a27.177,27.177,0,0,0,2.169,5.411,2.221,2.221,0,0,1-2.169.7Z",
    transform: "translate(59.156 44.265)",
    fill: "#df5753"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_261",
    "data-name": "Caminho 261",
    d: "M159.474,119.385c0,.866.459,1.569,1.025,1.569s1.025-.7,1.025-1.569-.459-1.569-1.025-1.569-1.025.7-1.025,1.569",
    transform: "translate(58.802 43.442)",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_262",
    "data-name": "Caminho 262",
    d: "M160.04,118.012l2.08-.6s-1.068,1.625-2.08.6",
    transform: "translate(59.011 43.293)",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_263",
    "data-name": "Caminho 263",
    d: "M141.426,127.384c1.25,6.371,2.5,18.047-1.963,22.3,0,0,1.742,6.464,13.582,6.464,13.019,0,6.222-6.463,6.222-6.463-7.105-1.7-6.922-6.968-5.684-11.919Z",
    transform: "translate(51.424 46.97)",
    fill: "#e58a7b"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_264",
    "data-name": "Caminho 264",
    d: "M138.381,121c.653,10.638.7,15.153,6.076,20.613,8.081,8.214,21,5.085,23.541-5.534,2.284-9.556.834-25.347-9.58-29.581A14.536,14.536,0,0,0,138.381,121",
    transform: "translate(51.014 38.854)",
    fill: "#e58a7b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_265",
    "data-name": "Caminho 265",
    d: "M142.17,108.13c-5.334,1.945-12.45.5-9.658,16.963,2.956,17.432-1.595,23.167-1.595,23.167s20.246,4.313,40.914-.257c0,0-6.31-11.036-4.54-19.087,2.258-10.27.469-14.065.469-14.065s-18.089-9.455-25.591-6.72",
    transform: "translate(48.273 39.687)",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_266",
    "data-name": "Caminho 266",
    d: "M155.64,121.641a10.724,10.724,0,0,0,1.675,5.7c1.443,2.219,3.152,1.315,3.581-.987.386-2.072.1-5.724-1.747-7.141-1.818-1.395-3.483.012-3.509,2.423",
    transform: "translate(57.389 43.755)",
    fill: "#e58a7b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_267",
    "data-name": "Caminho 267",
    d: "M135.808,111.732c-1.54-4.3,5.775-10.925,21.239-8.171s16.141,15.614,16.141,15.614l-3.129-3.713.141,3.91-15.892,3.054Z",
    transform: "translate(50.002 37.946)",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_268",
    "data-name": "Caminho 268",
    d: "M136.721,145.447h0a2.41,2.41,0,0,1,1.985-2.77c4.817-.8,15.759-2.406,21.269-1.642,4.092.567,5.175,2.956,5.348,4.911a2.413,2.413,0,0,1-2.524,2.6L139,147.475a2.417,2.417,0,0,1-2.276-2.028",
    transform: "translate(50.401 51.929)",
    fill: "#407bff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135",
    transform: "translate(187.089 192.762)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    "data-name": "Grupo 133",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_269",
    "data-name": "Caminho 269",
    d: "M136.721,145.447h0a2.41,2.41,0,0,1,1.985-2.77c4.817-.8,15.759-2.406,21.269-1.642,4.092.567,5.175,2.956,5.348,4.911a2.413,2.413,0,0,1-2.524,2.6L139,147.475a2.417,2.417,0,0,1-2.276-2.028",
    transform: "translate(-136.688 -140.833)"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_270",
    "data-name": "Caminho 270",
    d: "M146.76,324.3l8.821,6.124,14.77-20.018-8.82-6.124Z",
    transform: "translate(54.115 112.198)",
    fill: "#e58a7b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_271",
    "data-name": "Caminho 271",
    d: "M131.715,324.317l9.332,5.313,13.073-21.171-9.331-5.313Z",
    transform: "translate(48.567 111.778)",
    fill: "#e58a7b"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_272",
    "data-name": "Caminho 272",
    d: "M168.42,310.411l-7.611,10.32-8.826-6.126,7.613-10.32Z",
    transform: "translate(56.04 112.198)",
    fill: "#cf6f64"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_273",
    "data-name": "Caminho 273",
    d: "M143.08,303.149l9.335,5.316-6.744,10.91-9.335-5.316Z",
    transform: "translate(50.271 111.779)",
    fill: "#cf6f64"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_274",
    "data-name": "Caminho 274",
    d: "M161.486,193.036s34.465,43.437,28,84.973c-5.222,33.55-35.466,78.98-35.466,78.98L139.8,349.921s15.452-30.191,25.6-62.2A45.974,45.974,0,0,0,159.88,247.9c-17.458-25.5-45.428-10.327-26.614-54.861Z",
    transform: "translate(46.832 71.178)",
    fill: "#407bff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    transform: "translate(173.842 264.214)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_275",
    "data-name": "Caminho 275",
    d: "M161.486,193.036s34.465,43.437,28,84.973c-5.222,33.55-35.466,78.98-35.466,78.98L139.8,349.921s15.452-30.191,25.6-62.2A45.974,45.974,0,0,0,159.88,247.9c-17.458-25.5-45.428-10.327-26.614-54.861Z",
    transform: "translate(-127.01 -193.036)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141",
    transform: "translate(220.216 287.145)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_276",
    "data-name": "Caminho 276",
    d: "M165.9,214.769l-5.007-4.979c0,.394,9.7,60.3,12.434,77.135A102.683,102.683,0,0,0,177,271.832c3.165-20.338-3.489-41.14-11.1-57.062",
    transform: "translate(-160.891 -209.79)"
  }))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_277",
    "data-name": "Caminho 277",
    d: "M174.32,193.036s41.5,54.585,42.666,87.318c.977,27.427-45.2,80.406-45.2,80.406l-13.407-8.674s27-37.663,33.8-68.45c-2.592-30.475-58.228-90.6-58.228-90.6Z",
    transform: "translate(49.391 71.178)",
    fill: "#407bff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(183.34 264.214)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_278",
    "data-name": "Caminho 278",
    d: "M174.32,193.036s41.5,54.585,42.666,87.318c.977,27.427-45.2,80.406-45.2,80.406l-13.407-8.674s27-37.663,33.8-68.45c-2.592-30.475-58.228-90.6-58.228-90.6Z",
    transform: "translate(-133.949 -193.036)"
  }))))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_279",
    "data-name": "Caminho 279",
    d: "M128.274,145.508c-4.444,1.048-8.691,17.182-8.691,17.182l17.332,11.57s5.775-12.751,3.759-18.337c-2.1-5.817-6.788-11.738-12.4-10.415",
    transform: "translate(44.093 53.584)",
    fill: "#4d4c92"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    transform: "translate(174.55 209.473)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_280",
    "data-name": "Caminho 280",
    d: "M128.737,153.042,127.526,167.1l6.454,4.318a57.75,57.75,0,0,0,3.924-12.5Z",
    transform: "translate(-127.527 -153.042)"
  }))))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281",
    "data-name": "Caminho 281",
    d: "M182.407,146.523s5.115,1.8-5.131,64.811H133.664c.731-17.75.751-28.7-7.732-65.121a128.594,128.594,0,0,1,18.52-2.44,138.832,138.832,0,0,1,19.8,0c8.507.777,18.152,2.751,18.152,2.751",
    transform: "translate(46.435 52.88)",
    fill: "#4d4c92"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282",
    "data-name": "Caminho 282",
    d: "M173.241,154.186c.988,2.731,2.034,5.684,3.122,8.52q1.564,4.32,3.247,8.613l3.356,8.6.849,2.149.426,1.074.214.537c.037.1.03.088.016.078a3.007,3.007,0,0,0-.958-.854,3.816,3.816,0,0,0-1.788-.523,3.533,3.533,0,0,0-1.522.276c-.617.294-.627.42-.613.4a1.745,1.745,0,0,0,.307-.309,19.638,19.638,0,0,0,1.956-3.189c.647-1.257,1.259-2.6,1.868-3.957,1.211-2.729,2.313-5.575,3.434-8.427s2.153-5.76,3.188-8.671l3.117-8.735,5.274,1.329c-1.044,6.248-2.393,12.369-4,18.511-.786,3.077-1.694,6.128-2.733,9.207-.517,1.544-1.1,3.081-1.762,4.65a28.591,28.591,0,0,1-2.6,4.952,12.153,12.153,0,0,1-1.194,1.475,7.627,7.627,0,0,1-2.494,1.762,6.138,6.138,0,0,1-2.657.5,6.075,6.075,0,0,1-2.889-.871,7.227,7.227,0,0,1-2.488-2.584c-.209-.348-.386-.706-.509-.965l-.26-.531-.519-1.061-1.036-2.126c-1.351-2.848-2.676-5.712-3.932-8.608s-2.454-5.82-3.63-8.76c-1.124-2.985-2.235-5.877-3.223-9.053Z",
    transform: "translate(60.03 55.222)",
    fill: "#e58a7b"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283",
    "data-name": "Caminho 283",
    d: "M170.634,145.8c5.242,1.248,11.132,16.737,11.132,16.737l-15.579,13.275s-10.1-16.89-8.054-22.466c2.127-5.807,5.653-9.177,12.5-7.546",
    transform: "translate(58.207 53.607)",
    fill: "#4d4c92"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284",
    "data-name": "Caminho 284",
    d: "M187.662,147.469l5.468-4.573,3.8,5.925-2.8,4.948s-4.462,4.084-8.412,2.007a7.1,7.1,0,0,1,1.944-8.307",
    transform: "translate(68.257 52.69)",
    fill: "#e58a7b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285",
    "data-name": "Caminho 285",
    d: "M200.9,142.91l-.409,1.491-8.661,1.455-.854-2.959Z",
    transform: "translate(70.416 52.69)",
    fill: "#e58a7b"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286",
    "data-name": "Caminho 286",
    d: "M166.612,320.136l-15.628-10.111,2.8-4.866,17.565,10.8Z",
    transform: "translate(55.672 112.52)",
    fill: "#4d4c92"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287",
    "data-name": "Caminho 287",
    d: "M144.06,322.653a9.371,9.371,0,0,1-3.869-1.34.252.252,0,0,1-.129-.248.257.257,0,0,1,.175-.218c.422-.133,4.129-1.269,5.179-.387a.868.868,0,0,1,.292.825,1.441,1.441,0,0,1-.772,1.185,1.937,1.937,0,0,1-.876.182m-3.078-1.493c1.7.865,3.069,1.184,3.727.857a.959.959,0,0,0,.5-.8.36.36,0,0,0-.116-.367c-.552-.464-2.607-.1-4.108.309",
    transform: "translate(51.644 118.04)",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288",
    "data-name": "Caminho 288",
    d: "M140.314,322.161a.254.254,0,0,1-.244-.323c.036-.127.89-3.1,2.294-3.776a1.334,1.334,0,0,1,1.128-.034.887.887,0,0,1,.631.916c-.1,1.23-2.6,2.93-3.749,3.21a.221.221,0,0,1-.06.008m2.655-3.734a.881.881,0,0,0-.383.093c-.838.4-1.541,2.008-1.877,2.984,1.2-.506,2.85-1.851,2.909-2.6.008-.122-.019-.281-.322-.406a.838.838,0,0,0-.327-.07",
    transform: "translate(51.644 117.225)",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289",
    "data-name": "Caminho 289",
    d: "M158.6,327.273c-1.541,0-3.69-1.981-4.866-3.2a.25.25,0,0,1-.045-.29.274.274,0,0,1,.259-.14c.542.071,5.3.713,5.976,2.059a.82.82,0,0,1-.033.8,1.406,1.406,0,0,1-1.083.757,1.757,1.757,0,0,1-.208.012m-3.965-3.014c1.73,1.681,3.241,2.612,4.11,2.5a.909.909,0,0,0,.7-.5.311.311,0,0,0,.019-.322c-.365-.732-2.907-1.362-4.833-1.671",
    transform: "translate(56.659 119.336)",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_290",
    "data-name": "Caminho 290",
    d: "M154.783,324.86a5.145,5.145,0,0,1-.914-.068.256.256,0,0,1-.193-.161.259.259,0,0,1,.042-.251c.078-.094,1.93-2.327,3.681-2.48a1.847,1.847,0,0,1,1.407.442c.539.461.5.872.375,1.135-.434.912-2.8,1.384-4.4,1.384m-.353-.513c1.529.085,3.973-.423,4.292-1.089.027-.056.108-.224-.246-.528a1.332,1.332,0,0,0-1.032-.323c-1.15.1-2.432,1.319-3.014,1.941",
    transform: "translate(56.659 118.691)",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_291",
    "data-name": "Caminho 291",
    d: "M145.016,320.859l-11.61-3.282a.851.851,0,0,0-1.024.474l-3.919,8.81a1.725,1.725,0,0,0,1.137,2.306c4.066,1.074,6.084,1.388,11.189,2.831,3.141.888,7.638,2.512,11.975,3.738,4.242,1.2,5.78-3,4.084-3.9-7.606-4.031-8.206-6.794-10.286-9.856a2.8,2.8,0,0,0-1.548-1.124",
    transform: "translate(47.319 117.087)",
    fill: "#4d4c92"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_292",
    "data-name": "Caminho 292",
    d: "M158.8,324.688l-9.91-6.881a.849.849,0,0,0-1.122.115l-6.573,7.056a1.726,1.726,0,0,0,.326,2.551c3.5,2.339,5.3,3.292,9.659,6.317,2.681,1.861,8.034,5.991,11.735,8.561,3.622,2.513,6.443-.954,5.13-2.356-5.88-6.287-7.178-10.226-8.148-13.8a2.808,2.808,0,0,0-1.1-1.566",
    transform: "translate(51.907 117.125)",
    fill: "#4d4c92"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_293",
    "data-name": "Caminho 293",
    d: "M152.889,317.179l-17.87-8.882,1.85-4.836,19.073,9.35Z",
    transform: "translate(49.785 111.894)",
    fill: "#4c4b97"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294",
    "data-name": "Caminho 294",
    d: "M131.521,191.254l-1.512,3.9c-.152.3.207.612.71.612H176c.393,0,.719-.193.743-.439l.393-3.9c.027-.271-.313-.5-.743-.5H132.231a.791.791,0,0,0-.71.327",
    transform: "translate(47.925 70.4)",
    fill: "#4d4c92"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    transform: "translate(177.898 261.327)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    "data-name": "Caminho 295",
    d: "M131.521,191.254l-1.512,3.9c-.152.3.207.612.71.612H176c.393,0,.719-.193.743-.439l.393-3.9c.027-.271-.313-.5-.743-.5H132.231a.791.791,0,0,0-.71.327",
    transform: "translate(-129.973 -190.927)",
    fill: "#4d4c92"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    "data-name": "Caminho 296",
    d: "M136.733,196.286h-1.183c-.235,0-.415-.122-.4-.27l.554-5.073c.016-.148.222-.27.457-.27h1.184c.235,0,.415.122.4.27l-.554,5.073c-.016.148-.223.27-.459.27",
    transform: "translate(49.834 70.307)",
    fill: "#407bff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    "data-name": "Caminho 297",
    d: "M157.141,196.286h-1.183c-.235,0-.415-.122-.4-.27l.556-5.073c.015-.148.222-.27.457-.27h1.183c.235,0,.415.122.4.27l-.556,5.073c-.016.148-.222.27-.457.27",
    transform: "translate(57.358 70.307)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    transform: "translate(148.856 493.078)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    "data-name": "Caminho 298",
    d: "M108.755,362.905c-.067,1.47,16.3,2.662,36.548,2.664s36.724-1.189,36.791-2.659-16.295-2.662-36.548-2.664-36.724,1.189-36.791,2.659",
    transform: "translate(-108.755 -360.246)",
    fill: "#f5f5f5"
  }))))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    "data-name": "Caminho 299",
    d: "M164.277,407.432c-6.488-1.883-13.628-4.31-18.047-6.892-.122-.071-.252-.122-.378-.188v-29.33H158.9a3.906,3.906,0,1,0,0-7.813H145.853V229.315h-7.814V363.209H124.989a3.906,3.906,0,1,0,0,7.813h13.049v29.33c-.125.066-.255.116-.378.188-4.418,2.581-11.559,5.008-18.047,6.892a1.915,1.915,0,0,0,.537,3.753h43.59a1.915,1.915,0,0,0,.537-3.753",
    transform: "translate(43.596 84.555)",
    fill: "#e0e0e0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    "data-name": "Caminho 300",
    d: "M168.364,248.014H119.685a7.111,7.111,0,0,1-7.09-7.09V226.452a7.111,7.111,0,0,1,7.09-7.09h48.679a7.111,7.111,0,0,1,7.09,7.09v14.472a7.111,7.111,0,0,1-7.09,7.09",
    transform: "translate(41.517 80.885)",
    fill: "#4d4c92"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_301",
    "data-name": "Caminho 301",
    d: "M117.448,240.3v2.491c0,2.053,2.235,3.734,4.966,3.734h39.642c2.732,0,4.966-1.681,4.966-3.734V240.3Z",
    transform: "translate(43.306 88.603)",
    fill: "#e0e0e0"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156",
    transform: "translate(160.754 328.898)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    "data-name": "Caminho 302",
    d: "M117.448,240.3v2.491c0,2.053,2.235,3.734,4.966,3.734h39.642c2.732,0,4.966-1.681,4.966-3.734V240.3Z",
    transform: "translate(-117.448 -240.295)",
    fill: "#e0e0e0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvg);
export default __webpack_public_path__ + "static/media/LoginSVG.c31a5466e7ee3c3eebce100f402109db.svg";
export { ForwardRef as ReactComponent };